var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.$style.date) + " " + (_vm.error ? _vm.$style.error : '')),attrs:{"title":_vm.error}},[_vm._v("\n  "+_vm._s(_vm.dateString)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }